<script>
  import VueBase64FileUpload from 'vue-base64-file-upload'
  import AppPageHeader from '../../../components/main/PageHeader'

  import * as restfulService from '../../../services/restfulService'
  import * as MESSAGES from '../../../messages'

  import bus from '@utils/bus'
  import helpers from '@mixins/helper'
  import {mapGetters, mapActions} from 'vuex'

  import {required, requiredIf, minLength} from 'vuelidate/lib/validators'

  export default {
    components: {VueBase64FileUpload, AppPageHeader},
    mixins: [helpers],
    data () {
      return {
        botaoClicado: false,
        tamanhoMaximoEmMB: 5,
        imagem: {
          nome: '',
          tamanho: '',
          base64: ''
        },
        mostrarModalSenha: false,
        senha: {
          senhaAtual: '',
          novaSenha: '',
          novaSenhaConfirmacao: ''
        },
        tipoAlteracaoSenha: 'souurcamp'
      }
    },
    validations: {
      senha: {
        senhaAtual: {
          required: requiredIf(function () {
            return this.tipoAlteracaoSenha === 'souurcamp'
          })
        },
        novaSenha: {required, minLength: minLength(6)},
        novaSenhaConfirmacao: {required}
      }
    },
    computed: {
      ...mapGetters(['currentUser']),
      avatar: function () {
        return this.currentUser.avatar
      },
      senhaAtualErros () {
        const erros = []
        if (!this.$v.senha.senhaAtual.$dirty) return erros
        !this.$v.senha.senhaAtual.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        return erros
      },
      senhaNovaSenhaErros () {
        const erros = []
        if (!this.$v.senha.novaSenha.$dirty) return erros
        !this.$v.senha.novaSenha.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        !this.$v.senha.novaSenha.minLength && erros.push('A senha precisa ter no mínimo 6 caracteres')
        return erros
      },
      senhaNovaSenhaConfirmacaoErros () {
        const erros = []
        if (!this.$v.senha.novaSenhaConfirmacao.$dirty) return erros
        !this.$v.senha.novaSenhaConfirmacao.required && erros.push(MESSAGES.VALIDATION_REQUIRED)
        if (this.senhasDiferentes) {
          erros.push('As senhas precisam ser iguais')
        }
        return erros
      },
      senhasDiferentes () {
        return this.senha.novaSenha !== this.senha.novaSenhaConfirmacao
      }
    },
    mounted () {
      bus.$on('alterar-senha-email-academico', () => {
        this.abrirModalAlterarSenha(true)
      })
    },
    methods: {
      ...mapActions(['setUser', 'showNotification']),
      resizeAndUpload (file) {
        let vm = this
        let reader = new window.FileReader()
        reader.onloadend = function () {
          let tempImg = new window.Image()
          tempImg.src = reader.result
          tempImg.onload = function () {
            let MAX_WIDTH = 600
            let MAX_HEIGHT = 600
            let tempW = tempImg.width
            let tempH = tempImg.height
            if (tempW > tempH) {
              if (tempW > MAX_WIDTH) {
                tempH *= MAX_WIDTH / tempW
                tempW = MAX_WIDTH
              }
            } else {
              if (tempH > MAX_HEIGHT) {
                tempW *= MAX_HEIGHT / tempH
                tempH = MAX_HEIGHT
              }
            }
            let canvas = document.createElement('canvas')
            canvas.width = tempW
            canvas.height = tempH
            let ctx = canvas.getContext('2d')
            ctx.drawImage(this, 0, 0, tempW, tempH)
            let base64 = canvas.toDataURL('image/jpeg')
            vm.atualizarImagemPerfil(base64)
          }
        }
        reader.readAsDataURL(file)
      },
      selecionaImagem (e) {
        let filesToUpload = e.target.files
        if (filesToUpload.length > 0) {
          let file = filesToUpload[0]
          this.resizeAndUpload(file)
        }
      },
      atualizarImagemPerfil (imagem) {
        bus.$emit('show-loader')
        let data = { base64: imagem }
        restfulService.put('usuario', 'avatar', null, data)
          .then(() => {
            let usuario = this.currentUser
            usuario.avatar = imagem
            this.setUser(usuario)
            this.showNotification({
              message: 'Seu avatar foi atualizado'
            })
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      removerAvatar () {
        bus.$emit('show-loader')
        let data = {base64: ''}
        restfulService.put('usuario', 'avatar', null, data)
          .then(() => {
            let usuario = this.currentUser
            usuario.avatar = ''
            this.setUser(usuario)
            this.showNotification({
              message: 'Seu avatar foi atualizado'
            })
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      abrirModalAlterarSenha (emailAcademico) {
        this.$v.senha.$reset()
        this.tipoAlteracaoSenha = (emailAcademico ? 'emailacademico' : 'souurcamp')
        this.mostrarModalSenha = true
        setTimeout(() => {
          this.$nextTick(() => {
            if (emailAcademico) {
              this.$refs.novaSenha.focus()
            } else {
              this.$refs.senhaAtual.focus()
            }
          })
        }, 300)
      },
      alterarSenha () {
        bus.$emit('show-loader')
        let data = {
          senha_atual: this.senha.senhaAtual,
          nova_senha: this.senha.novaSenha,
          tipo_alteracao: this.tipoAlteracaoSenha
        }
        restfulService.put('usuario', 'alterar-senha', null, data)
          .then(() => {
            this.showNotification({
              message: 'Sua senha do ' + (this.tipoAlteracaoSenha === 'souurcamp' ? 'Sou URCAMP' : 'Email Acadêmico') + ' foi alterada'
            })
            this.senha = {
              senhaAtual: '',
              novaSenha: '',
              novaSenhaConfirmacao: ''
            }
            this.$v.senha.$reset()
            this.mostrarModalSenha = false
            bus.$emit('hide-loader')
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div class="page-content">
        <app-page-header/>
        <div class="minha-conta">
            <div class="meus-dados">
                <div class="box">
                    <div class="meu-avatar" v-bind:style="{ backgroundImage: 'url(' + avatar + ')' }">
                        <div class="overlay">
                            <i class="fas fa-camera"></i>
                            <span>Trocar imagem do perfil</span>
                        </div>
                        <div class="user-sigla"
                             key="avatarSigla"
                             v-if="!avatar">
                            {{currentUser.sigla}}
                        </div>
                        <div class="overlay-remover"
                             title="Remover Avatar"
                             key="avatarRemover"
                             v-if="avatar"
                             @click="removerAvatar">
                            <i class="fas fa-times"></i>
                        </div>
                        <div class="upload-box" @click="$refs.uploadFile.click()">
                            <input type="file"
                                   ref="uploadFile"
                                   class="upload-file"
                                   @change="selecionaImagem"
                                   accept="image/png,image/jpeg,image/jpg"/>
                        </div>
                    </div>
                    <h3>{{currentUser.pessoa.nome}}</h3>
                    <h4>{{currentUser.ref_pessoa}}</h4>
                    <nav class="menu-conta">
                        <router-link :to="{name: 'minha-conta.inicial'}">
                            <i class="fas fa-home"></i>
                            <span class="pl-2">Inicial</span>
                        </router-link>
                        <router-link :to="{name: 'minha-conta.dados-cadastrais'}">
                            <i class="fas fa-user"></i>
                            <span class="pl-2">Editar Meus Dados</span>
                        </router-link>
                        <router-link :to="{name: 'minha-conta.notificacoes'}">
                            <i class="fas fa-bell"></i>
                            <span class="pl-2">Notificações e SMS</span>
                        </router-link>
                        <a href="#" @click="abrirModalAlterarSenha(false)">
                            <i class="fas fa-lock"></i>
                            <span class="pl-2">Alterar Senha</span>
                        </a>
                    </nav>
                </div>
            </div>
            <div class="formulario">
                <div class="box">
                    <router-view></router-view>
                </div>
            </div>
        </div>
        <v-dialog v-model="mostrarModalSenha" :width="isMobile().any() ? '90%' : '60%'">
            <v-card class="modal-alterar-senha">
                <v-card-title class="primary white--text"
                              >
                    Alteração de Senha: {{tipoAlteracaoSenha === 'souurcamp' ? 'Sou URCAMP' : 'Email Acadêmico'}}
                </v-card-title>
                <v-card-text>
                    <v-container fluid grid-list-md>
                        <v-layout row wrap>
                            <v-flex sm4 xs12 v-if="tipoAlteracaoSenha === 'souurcamp'">
                                <v-text-field v-model="senha.senhaAtual"
                                              type="password"
                                              ref="senhaAtual"
                                              :error-messages="senhaAtualErros"
                                              @input="$v.senha.senhaAtual.$touch()"
                                              @blur="$v.senha.senhaAtual.$touch()"
                                              label="Senha Atual"
                                              required/>
                            </v-flex>
                            <v-flex sm4 xs12>
                                <v-text-field v-model="senha.novaSenha"
                                              type="password"
                                              ref="novaSenha"
                                              :error-messages="senhaNovaSenhaErros"
                                              @input="$v.senha.novaSenha.$touch()"
                                              @blur="$v.senha.novaSenha.$touch()"
                                              label="Nova Senha"
                                              required/>
                            </v-flex>
                            <v-flex sm4 xs12>
                                <v-text-field v-model="senha.novaSenhaConfirmacao"
                                              type="password"
                                              :error-messages="senhaNovaSenhaConfirmacaoErros"
                                              @input="$v.senha.novaSenhaConfirmacao.$touch()"
                                              @blur="$v.senha.novaSenhaConfirmacao.$touch()"
                                              label="Confirmação da Nova Senha"
                                              required/>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success"
                           @click="alterarSenha"
                           :disabled="botaoClicado || $v.senha.$invalid || senhasDiferentes || !tipoAlteracaoSenha.length">
                        Alterar Senha
                    </v-btn>
                    <v-btn flat @click="mostrarModalSenha = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<style lang="scss">
    .box-local {
        padding-top: 8px;
        padding-bottom: 15px;
        .v-input--selection-controls {
            margin-top: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// MinhaConta.vue?0c09d652